import styled from '@emotion/styled';

const AmbGrid = styled.div`
  display: flex;
`;

export default AmbGrid;
